export * from './delete-rolle.component';
export * from './delete-rolle.component.module';